import Shopify from '../utils/Shopify.js'
import AppAddCart from '../app-add-cart'
import MixinResize from '../mixin-resize'

const shopify = new Shopify()

export default
{
    mixins: [
        MixinResize
    ],

    components:
    {
        AppAddCart
    },

    props:
    {
        products: { type: Array, default: [] },
        color: { type: String, default: 'sand-light' }
    },

    watch:
    {
        products: 'init'
    },

    data()
    {
        return {
            items: []
        }
    },

    created()
    {
        this.init(this.products)
    },

    methods:
    {
        onImgLoaded()
        {
            this.$nextTick(() => this.resize.dispatch())
        },

        onResized()
        {
            // Hide warning
        },

        rollOutProduct(index)
        {
            this.$refs.addCartButton[index].hideNum()
        },

        init(products)
        {
            const list = JSON.parse(JSON.stringify(products))
            shopify.getItems(items =>
            {
                list.forEach(product =>
                {
                    const item = items.find(({ slug }) => slug === product.slug)
                    if (item) {
                        product.price = item.variants[0].price
                    }
                })

                this.items = list
            })
        }
    }
}